<script>
  import Icon from "./Icon.svelte";
  import { selectedPerformanceMeasures } from "@stores/userData.js";

  let index = 0;
  export let active;

  $: $selectedPerformanceMeasures, (index = 0);
  $: currentMeasure = $selectedPerformanceMeasures[index];

  const increment = () => {
    index++;
    if (index >= $selectedPerformanceMeasures.length) {
      index = 0;
    }
  };

  let toNum = (num) => {
    return parseFloat(num.toString().split(",").join(""));
  };

  function exists(val) {
    return val != "#N/A" && !isNaN(toNum(val));
  }

  $: max = currentMeasure
    ? exists(currentMeasure.FY2020) && exists(currentMeasure.FY2015)
      ? Math.max(toNum(currentMeasure.FY2020), toNum(currentMeasure.FY2015))
      : exists(currentMeasure.FY2020)
      ? toNum(currentMeasure.FY2020)
      : exists(currentMeasure.FY2015)
      ? toNum(currentMeasure.FY2015)
      : 0
    : 0;

  import { format } from "d3-format";
  const suffixFormat = format(",.3s");
</script>

{#if $selectedPerformanceMeasures.length > 1}
  <button tabindex={active ? 0 : -1} on:click={increment}>Change</button>
{/if}

<div class="shareable-card">
  {#if currentMeasure}
    <!-- MINOR FIXME: Better word than "something": one outcome? one priority? one goal? -->
    <h1>Something I think needs more<br />attention this budget cycle:</h1>
    <div
      class="dept"
      style="width: {exists(currentMeasure.FY2015) ||
      exists(currentMeasure.FY2020)
        ? '70%'
        : '95%'}"
    >
      <h2>{currentMeasure.Measure}</h2>
      {#if currentMeasure.Division}<h3>
          {currentMeasure.Division} Division
        </h3>{/if}
      <h4>{currentMeasure.Department}</h4>
    </div>

    <div class="barchart">
      {#if exists(currentMeasure.FY2015)}
        <div
          class="bar"
          data-year="2015"
          style="height: {(toNum(currentMeasure.FY2015) / max) * 100}%;"
        >
          <span
            >{currentMeasure.FY2015.toString().includes("%")
              ? currentMeasure.FY2015
              : suffixFormat(toNum(currentMeasure.FY2015))}</span
          >
        </div>
      {/if}
      {#if exists(currentMeasure.FY2020)}
        <div
          class="bar"
          data-year="2020"
          style="height: {(toNum(currentMeasure.FY2020) / max) * 100}%;"
        >
          <span
            >{currentMeasure.FY2020.toString().includes("%")
              ? currentMeasure.FY2020
              : suffixFormat(toNum(currentMeasure.FY2020))}</span
          >
        </div>
      {/if}
    </div>

    <span class="shareable-card-footer"
      >Make your voice heard at <strong>houstonbudget.cool</strong></span
    >
    <div class="icon-container">
      <Icon src="{currentMeasure.Department}.png" />
    </div>
  {/if}
</div>

<style>
  h1 {
    position: absolute;
    width: 100%;
    top: 5%;
    font-size: 3.75vw;
    font-weight: 200;
    line-height: 1.15;
    text-align: center;
  }

  .dept {
    line-height: 1.15;
    position: absolute;
    top: 30%;
    left: 1.5vw;
    font-weight: bold;
    text-align: left;
    width: 75%;
  }

  .dept h2 {
    font-size: 5vw;
    margin-bottom: 1.75vw;
    line-height: 1;
  }

  .dept h3 {
    font-size: 3vw;
    text-transform: uppercase;
  }

  .dept h4 {
    font-size: 2vw;
    text-transform: uppercase;
    color: rgba(var(--primary-color-rgb), 0.75);
  }

  .icon-container {
    max-width: 10vw;
    position: absolute;
    bottom: 1vh;
    left: 1.5vw;
  }

  .barchart {
    position: absolute;
    height: 20%;
    width: 20vw;
    right: 1.5vw;
    top: 50%;
    display: flex;
    place-items: flex-end;
  }

  .bar {
    margin-right: 0.1vw;
    justify-content: center;
    place-items: flex-start;
    padding-top: 1vw;
    display: flex;
    width: 100%;
    background: white;
  }

  .bar::after {
    content: attr(data-year);
    position: absolute;
    bottom: -3vw;
    font-size: 2vw;
    color: white;
  }

  .bar span {
    color: var(--accent-color);
    font-size: 2vw;
    font-family: "Courier New", Courier, monospace;
  }

  button {
    pointer-events: all;
    z-index: 0;
    position: absolute;
    bottom: -2.15rem;
    right: 0;
    padding: 0.5rem 1rem 0.45rem 1rem;
    border: 1px solid var(--accent-color);
    cursor: pointer;
    background: var(--primary-color);
    font-family: var(--font-serif);
    color: var(--accent-color);
  }
</style>
